import {createFileRoute} from "@tanstack/react-router";
import {parseAdminUdoViewerSearch, fetchViewerWorkspaces, adminUdoViewerQueryKey} from "~/domainModels/adminModels/adminUdoDataViewer";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/udo-data-viewer")({
    validateSearch: parseAdminUdoViewerSearch,
    loader: async ({context}) => {
        const api = {intellsysBaseUrl: context.intellsysBaseUrl, accessToken: context.authenticationStatus.accessToken};
        const workspaces = await context.queryClient.ensureQueryData({
            queryKey: [...adminUdoViewerQueryKey(api), "workspaces"],
            queryFn: () => fetchViewerWorkspaces(api),
        });
        return {...api, workspaces};
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
